<div style="width: 100%; overflow: hidden;" class="signature-container">
    <canvas #canvas
            (pointerdown)="startDrawing($event)"
            (pointermove)="draw($event)"
            (pointerup)="stopDrawing()"
            (pointerleave)="stopDrawing()"
            [ngClass]="{'error': isSignatureValid}"></canvas>

    <div class="validation error">
        <span *ngIf="isSignatureValid">
        {{"SignatureNotValid" | localize}}
        </span>
    </div>
</div>
<div class="p-mt-2 d-flex gap-2 p-jc-end">
    <button class="btn btn-primary" (click)="clearCanvas()">Clear</button>
<!--    <button class="btn btn-primary" (click)="drawBoundingBoxForAllPaths()">Box</button>-->
</div>
